import React from 'react';
import { formatDate, excerpt, getSection } from './content';

export default function PostCard({ post, navigate, showSection = true }) {
  const section = getSection(post.section);

  return (
    <article
      className="post-card glass-card"
      onClick={() => navigate('post', post.slug)}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          navigate('post', post.slug);
        }
      }}
      role="link"
      tabIndex={0}
    >
      {post.hero_image && (
        <div className="card-img-wrap">
          <img
            src={post.hero_image}
            alt=""
            className="card-img"
            loading="lazy"
            onError={(e) => {
              e.currentTarget.closest('.card-img-wrap').style.display = 'none';
            }}
          />
        </div>
      )}

      <div className="card-body">
        <div className="card-meta">
          {showSection && section && (
            <span className="tag">{section.label}</span>
          )}
          {post.date && <span className="card-date">{formatDate(post.date)}</span>}
        </div>
        <h3 className="card-title">{post.title}</h3>
        <p className="card-excerpt">{excerpt(post.content)}</p>
      </div>
    </article>
  );
}
